// Инициализация трекинга ошибок (GlitchTip).
//
// Приёмник — GlitchTip, но SDK сентриевский: GlitchTip реализует протокол
// Sentry, поэтому смена бэкенда стоит смены DSN, а не переписывания кода.
//
// Импортируется первой строкой main.tsx — до React и стора: SDK должен
// перехватывать ошибки, случившиеся уже на этапе инициализации приложения.
//
// DSN вшивается в бандл при сборке (webpack.DefinePlugin), поэтому смена
// требует пересборки образа. Секретом он не является — это адрес приёмника.
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'stage',

        // Полноценная трассировка у GlitchTip в бете и без интерфейса —
        // транзакции не шлём.
        tracesSampleRate: 0,

        // Session replay ведёт Umami (на admin он не подключён намеренно:
        // аналитика внутренней панели не нужна).
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,

        // Шум, который не о нашем коде: расширения браузера, антивирусы,
        // оборванные загрузки чанков при деплое.
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            /^Loading chunk \d+ failed/,
            /^Failed to fetch dynamically imported module/
        ]
    });
}
